var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"pb-4"},[_vm._v("Flygresor")]),(_vm.flights)?_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.flights,"fields":_vm.fields}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }